<template>
  <div
    id="delete-label-modal"
    class="modal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body p-0">
          <div class="p-5 text-center">
            <XCircleIcon class="w-16 h-16 text-theme-6 mx-auto mt-3" />
            <div class="text-3xl mt-5">
              {{ $t("administration.Are you sure?") }}
            </div>
          </div>
          <div class="px-5 pb-8 text-center">
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-outline-secondary w-24 mr-1"
              @click="closeModal"
            >
              {{ $t("administration.Cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="deleteLabel()"
            >
              {{ $t("administration.Delete label") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Toastify from 'toastify-js'
import AdministrationService from '@/services/AdministrationService'
import moment from 'moment-timezone'

export default {
  name: 'DeleteLabelModal',
  props: {
    labelToDelete: {
      type: String,
      default: ''
    }
  },
  emits: ['deleted'],
  created() {
    this.moment = moment
  },
  methods: {
    deleteLabel(){
      AdministrationService.deleteLabel(this.labelToDelete)
          .then(response => {
            this.showToast('Label successfully deleted')
            this.$emit('deleted')
            this.closeModal()
          })
          .catch(err => {
            let error = ''
            console.log(err)
            this.showToast('Label could not be deleted, please contact the Sysadmin of your organization')
            this.closeModal()
          })
    },
    showModal() {
      cash('#delete-label-modal').modal('show')
    },
    closeModal() {
      cash('#delete-label-modal').modal('hide')
    },
    showToast(text) {
      Toastify({
        text: text,
        duration: 5000,
        newWindow: true,
        close: true,
        gravity: 'top',
        position: 'right',
        stopOnFocus: true,
        className: 'toastify-content'
      }).showToast()
    }
  }
}
</script>
